/* ============================================================
   P2-13: 7-DAY POPUP SUPPRESSION (FIXED)
   ============================================================ */
document.addEventListener('click', function(e) {
  if (e.target.closest('.newsletter-popup__close') || e.target.closest('.popup__close')) {
    const d = new Date();
    d.setTime(d.getTime() + (7 * 24 * 60 * 60 * 1000));
    const expires = "expires=" + d.toUTCString();
    document.cookie = "newsletter_dismissed=true;" + expires + ";path=/";
  }
});

window.addEventListener('load', function() {
  if (document.cookie.indexOf("newsletter_dismissed=true") > -1) {
    const popup = document.querySelector('.newsletter-popup, .popup--newsletter');
    if (popup) popup.style.display = 'none';
  }
});

/* ============================================================
   P2-14: RECENTLY VIEWED - PDP ONLY TRACKING
   ============================================================ */
(function() {
  const KEY = 'rv_products_v2';
  if (window.location.pathname.startsWith('/products/')) {
    try {
      const handle = window.location.pathname.split('/products/')[1].split('/')[0];
      if (handle) {
        let list = JSON.parse(localStorage.getItem(KEY) || '[]');
        list = list.filter(h => h !== handle);
        list.unshift(handle);
        localStorage.setItem(KEY, JSON.stringify(list.slice(0, 8)));
      }
    } catch (e) {
      console.warn('Recently Viewed logic skipped:', e);
    }
  }
})();

/* ============================================================
   P2-15: FORCE MONEY FORMAT FOR APPS
   ============================================================ */
window.money_format = "${{amount}} USD";
window.Shopify = window.Shopify || {};
window.Shopify.money_format = "${{amount}} USD";
